import { JobModel, ListResponseModel, QueryParamModel } from 'models';
import { EntityService } from 'utils/entityService';
import request, { Methods } from 'utils/request';
import { Mock } from 'utils/mockDecorator';
import { mockListResponse } from 'mock/list';

class ImportTaskService extends EntityService {
  constructor() {
    super('admin/upload-order');
  }

  @Mock((params: QueryParamModel) =>
    import('mock/importTasks').then((m) => mockListResponse(m.MOCK_IMPORT_TASKS, params))
  )
  async getTasks(params?: QueryParamModel | null) {
    return request<ListResponseModel<JobModel>>({
      method: Methods.GET,
      resource: `${this.resource}/jobs`,
      params,
    });
  }

  async getTaskById(id: ID) {
    return request<JobModel>({
      method: Methods.GET,
      resource: `${this.resource}/jobs/${id}`,
    });
  }

  async upload(data: any) {
    const formData = new FormData();
    formData.append('file', data as File | string);

    return request<JobModel>({
      method: Methods.POST,
      resource: this.resource,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: formData,
    });
  }

  async retryUpload(id: ID) {
    return request<JobModel>({
      method: Methods.POST,
      resource: `${this.resource}/jobs/${id}/retry`,
    });
  }

  async deleteTask(id: ID) {
    return request({
      method: Methods.DELETE,
      resource: `${this.resource}/jobs/${id}`,
    });
  }
}

export const importTaskService = new ImportTaskService();
